/**
 * Switcher de ORGANIZACIÓN ACTIVA (pieza 3 de MULTI_ORG_SWITCHER). Lista las
 * orgs del usuario y cambia el contexto activo (re-scopea reactivamente todas
 * las superficies vía el signal de módulo `lib/active-org.ts`).
 */
import { msg } from "@lingui/core/macro";
import { Show } from "solid-js";
import { Building2 } from "lucide-solid";
import { Select } from "@/components/ui/select";
import { showToast } from "@/components/ui/toast";
import { useI18n } from "@/providers/i18n-provider";
import { useActiveOrg } from "../hooks/use-active-org";

export function OrgSwitcher() {
  const { t } = useI18n();
  const { orgs, activeOrgId, setActiveOrg } = useActiveOrg();

  const change = async (orgId: string) => {
    try {
      await setActiveOrg(orgId);
    } catch (err) {
      console.error("Error switching organization:", err);
      showToast(t(msg`Error switching organization`), "error");
    }
  };

  return (
    <Show when={orgs().length > 1}>
      <div data-testid="org-switcher">
        <Select
          aria-label={t(msg`Active organization`)}
          icon={<Building2 class="h-4 w-4" />}
          value={activeOrgId()}
          onChange={change}
          triggerClass="w-56"
          options={orgs().map((o) => ({ value: o.id, label: o.name ?? o.slug ?? o.id }))}
        />
      </div>
    </Show>
  );
}
